import { Component, signal } from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { bootstrapBell, bootstrapInstagram, bootstrapTiktok } from '@ng-icons/bootstrap-icons';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { heroUsers } from '@ng-icons/heroicons/outline';
import { filter } from 'rxjs';
import { AccordionModule } from 'primeng/accordion';

@Component({
  selector: 'app-footer',
  imports: [
    RouterLink ,
    NgIcon,  
    AccordionModule

  ],
  viewProviders: [
    provideIcons({ heroUsers , bootstrapInstagram ,bootstrapTiktok ,bootstrapBell })],
  
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {

  currentRoute = signal<string>('');
   isLandingPage = signal<boolean>(false);
   isLoggedIn = signal<boolean>(false);
   isNotAuthPage = signal<boolean>(false);


   
  constructor(private router: Router ,
  ) {
   }
   ngOnInit() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
      this.currentRoute.set(event.urlAfterRedirects);
      // console.log('Current active route:', this.currentRoute());
      if(this.currentRoute() === '/student/login' || this.currentRoute() === '/student/signup') {
        this.isNotAuthPage.set(true);
      }else{
        if (this.currentRoute() === '/') {
          this.isLandingPage.set(true);
          this.isNotAuthPage.set(false); 
        } else{
          this.isLandingPage.set(false);
          this.isNotAuthPage.set(false);
        }
      }
      // console.log("isLanding" ,this.isLandingPage);
      // console.log("isLoggedIn",this.isLoggedIn);

    });

}
}